export class DocumentDetailModel {
    title: string;
    type: string;
    id?: number | undefined;
    customerID?: number | undefined;
    customerCode?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    statusName?: string | undefined;
    jobRef?: string | undefined;
    expiryDate?: Date | undefined;
    createdDate?: Date | undefined;
    requiredDate?: Date | undefined;
    branchID?: number | undefined;
    branchName?: string | undefined;
    currencyCode?: string | undefined;
    goodsTotal?: number | undefined;
    vatTax?: number | undefined;
    totalAmount?: number | undefined;
    totalMargin?: number | undefined;
    totalCost?: number | undefined;
    specOrder?: boolean | undefined;
    specOrderDesc?: string | undefined;
    noOfLines?: number | undefined;
    salesRepName?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAddress?: string | undefined;
    invoiceAddressCode?: string | undefined;
    invoiceAddress?: string | undefined;
    lines?: any[] | undefined;
    invoiceDate?: Date | undefined;
    dueDate?: Date | undefined;
    creditDate?: Date | undefined;
    description?: string | undefined;
    customerName?: string | undefined;
    tobranchName?: string | undefined;
    viabranchName?: string | undefined;
    createdBy?: string | undefined;
    orderNumber?: number | undefined;
    supplier?: string | undefined;
    orderType?: string | undefined;
    dateExpected?: Date | undefined;
    totalAdditionalCost?: number | undefined;
    totalWeight?: number | undefined;
    createdByName?: string | undefined;
    approvedByName?: string | undefined;
    approvedByNumber?: number | undefined;
    createdByContactNumber?: number | undefined;
    branchCode?: string | undefined;
}
